import { render, staticRenderFns } from "./formReviewBanefit.vue?vue&type=template&id=4ac1be06&scoped=true"
import script from "./formReviewBanefit.vue?vue&type=script&lang=js"
export * from "./formReviewBanefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1be06",
  null
  
)

export default component.exports